import React from "react";
// import AdminSidebar from "./AdminSidebar";
import "./admin.css";
import Nav from "../Navigation/nav";
import About from "../About/about";
import Services from "../Services/services";
import Portfolio from "../Portfolio/portfolio";
import Testimonial from "../Testimonial/testimonial";
import Contact from "../Contacts/contact";
import Footer from "../Footer/footer";
import Experiences from "../Experiences/experience";
import Header from "../Header/header";

const Site = () => {
  return (
    <div className="dashboard-container">
      {/* <AdminSidebar /> */}
      <Nav />
      <Header />
      <About />
      <Experiences />
      <Services />
      <Portfolio />
      <Testimonial />
      <Contact />
      <Footer />
    </div>
  );
};

export default Site;
